import { FormattedMessage } from 'react-intl';
import { SliderBox } from '../../molecules/slider-box';
import React from 'react';
import { SwitchBox } from '../../molecules/switch-box';
import { InputBox } from '../../molecules/input-box';
import { useSelector } from '../../store/utils';
import { get } from 'lodash';
import { ParentPaper } from '../../atoms/parent-paper';
import { HelpButton } from '../../atoms/help-button';
import { SettingsSpLocation } from '../../templates/settings/boxes/settings-sp-location';

export const SpotSettingsService = () => {
  const infigySmart = useSelector((s) => {
    return (
      s.variables.LICENSE == 3 ||
      s.variables.LICENSE == 4 ||
      s.variables.LICENSE == 5
    );
  });
  const spotInstaled = useSelector((s) => get(s.variables, 'SP_INSTALL'));

  return (
    <>
      <ParentPaper>
        {infigySmart && (
          <SwitchBox
            title={
              <FormattedMessage
                id="settings.spot.install"
                defaultMessage="Spotové obchodování aktivní"
              />
            }
            switchVariableId="SP_INSTALL"
            fullWidth
          />
        )}
      </ParentPaper>

      {spotInstaled && (
        <>
          <ParentPaper>
            <SettingsSpLocation />
          </ParentPaper>
          <ParentPaper>
            <SwitchBox
              title={
                <>
                  <FormattedMessage
                    id="settings.spot.battery_charge"
                    defaultMessage="Povoleno nabíjení baterie podle spotu"
                  />
                  <HelpButton
                    variant="dialog"
                    title={
                      <FormattedMessage
                        id="settings.spot.battery_charge"
                        defaultMessage="Povoleno nabíjení baterie podle spotu"
                      />
                    }
                    content={
                      <FormattedMessage
                        id="settings.spot.battery_charge.help"
                        defaultMessage="Pokud zvolíte tuto možnost, tak systém naplánuje nabíjení v době nejnižších cen. Bere v potaz aktuální úroveň nabití baterie a její kapacitu. Na základě těchto parametrů zvolí délku nabíjení tak, aby došlo k jejímu nabití za co nejnižší cenu."
                      />
                    }
                  />
                </>
              }
              switchVariableId="SP_BATTERY_CONTROL_SERVICE"
              subtitle={
                <FormattedMessage
                  id="settings.spot.battery_charge.subtitle"
                  defaultMessage="Řízení baterie podle spotu zvýší amortizaci baterie"
                />
              }
              visibility={{
                variableIds: ['SP_INSTALL', 'PV_BATTERY', 'PV_BATTERY_CONTROL'],
              }}
              fullWidth
            />
            <SliderBox
              title={
                <>
                  <FormattedMessage
                    id="settings.spot.battery_strategy"
                    defaultMessage="Strategie spotového nabíjení baterie"
                  />
                  <HelpButton
                    variant="dialog"
                    title={
                      <FormattedMessage
                        id="settings.spot.battery_strategy"
                        defaultMessage="Strategie spotového nabíjení baterie"
                      />
                    }
                    content={
                      <FormattedMessage
                        id="settings.spot.battery_strategy.help"
                        defaultMessage="Tímto posuvníkem můžete jednoduše nastavit preferenci využití baterie při spotovém obchodování. Nižší hodnoty (od 20 %) znamenají menší cyklování baterie a tedy méně časté nabíjení/vybíjení za spotové ceny. Vyšší hodnoty (až do 70 %) značí opak."
                      />
                    }
                  />
                </>
              }
              variableId="SP_MIN_SPOT_DIFFERENCE_BATTERY_SOC"
              subtitle={
                <FormattedMessage
                  id="settings.spot.battery_strategy_user.subtitle"
                  defaultMessage="20 % = Spíše využívat baterii pro FVE. 70 % = Spíše využívat baterii pro Spot."
                />
              }
              opts={{ style: 'percent', maximumFractionDigits: 0 }}
              min={20}
              max={70}
              visibility={{
                variableIds: [
                  'SP_INSTALL',
                  'PV_BATTERY',
                  'SP_BATTERY_CONTROL_SERVICE',
                  'PV_BATTERY_CONTROL',
                ],
              }}
            />
            <SwitchBox
              title={
                <FormattedMessage
                  id="settings.spot.battery_strategy_user"
                  defaultMessage="Umožnit nastavení strategie baterie uživatelem"
                />
              }
              subtitle={
                <FormattedMessage
                  id="settings.spot.battery_strategy_service.subtitle"
                  defaultMessage="Touto volbou povolíte koncovým uživatelům nastavit strategii baterie na záložce Spot"
                />
              }
              switchVariableId="SP_USER_ADVANCED_CONTROL"
              visibility={{
                variableIds: [
                  'SP_INSTALL',
                  'PV_BATTERY',
                  'SP_BATTERY_CONTROL_SERVICE',
                  'PV_BATTERY_CONTROL',
                ],
              }}
              fullWidth
            />
            <SliderBox
              title={
                <>
                  <FormattedMessage
                    id="settings.spot.min_difference_price_charge_from_grid"
                    defaultMessage="Minimální rozdíl ceny na spotu pro nabíjení baterie ze sítě"
                  />
                  <HelpButton
                    variant="dialog"
                    title={
                      <FormattedMessage
                        id="settings.spot.min_difference_price_charge_from_grid"
                        defaultMessage="Minimální rozdíl ceny na spotu pro nabíjení baterie ze sítě"
                      />
                    }
                    content={
                      <FormattedMessage
                        id="settings.spot.min_difference_price_charge_from_grid.help"
                        defaultMessage="Tímto parametrem je možné řídit nabíjení baterie ze spotu při nízkém rozdílu mezi nejnižší a nejvyšší cenou. Pokud je parametr 2 Kč a rozdíl mezi nejvyšší cenou (3 Kč) a nejnižší cenou (1 Kč) spotu je nižší, tak se ten den nabíjení baterie ze sítě nenaplánuje."
                      />
                    }
                  />
                </>
              }
              variableId="SP_MIN_SPOT_DIFFERENCE_PRICE"
              subtitle={
                <FormattedMessage
                  id="settings.spot.min_difference_price_charge_from_grid.subtitle"
                  defaultMessage="Minimální rozdíl ceny na spotu během dne, aby mohlo dojít k nabíjení baterie ze sítě"
                />
              }
              opts={{ style: 'currency' }}
              min={{ CZK: 1, EUR: 0.05 }}
              max={{ CZK: 5, EUR: 0.25 }}
              visibility={{
                variableIds: [
                  'SP_INSTALL',
                  'PV_BATTERY',
                  'SP_BATTERY_CONTROL_SERVICE',
                  'PV_BATTERY_CONTROL',
                ],
              }}
            />
          </ParentPaper>
          <ParentPaper>
            <SwitchBox
              title={
                <>
                  <FormattedMessage
                    id="settings.spot.battery_overflow"
                    defaultMessage="Povolit vybíjení baterie do sítě podle spotu"
                  />
                  <HelpButton
                    variant="dialog"
                    title={
                      <FormattedMessage
                        id="settings.spot.battery_overflow"
                        defaultMessage="Povolit vybíjení baterie do sítě podle spotu"
                      />
                    }
                    content={
                      <FormattedMessage
                        id="settings.spot.battery_overflow.help"
                        defaultMessage="Pokud zvolíte tuto možnost, tak systém naplánuje vybíjení baterie do sítě v době nejvyšší denní ceny a vybije jen tu energii, která nebude potřeba na běžnou spotřebu objektu. Parametry níže je možné definovat výši ceny pro vybítí celé kapacity baterie a vybítí jen té části kapacity baterie, která nebude potřeba pro noční spotřebu. "
                      />
                    }
                  />
                </>
              }
              switchVariableId="SP_DISCHARGE_TO_GRID_SER"
              subtitle={
                <FormattedMessage
                  id="settings.spot.battery_overflow.subtitle"
                  defaultMessage="Umožní vybít nadbytek energie z baterie do sítě v nejvýhodnější hodinu"
                />
              }
              visibility={{
                variableIds: ['SP_INSTALL', 'PV_BATTERY', 'PV_BATTERY_CONTROL'],
              }}
              fullWidth
            />
          </ParentPaper>
        </>
      )}
    </>
  );
};
